const SIMPLE_PATTERNS = [
  '123456',
  '12345678',
  '123456789',
  '1234567890',
  'password',
  'qwerty',
  'abc123',
  '111111',
  '123123',
  'admin',
  'letmein',
  'welcome',
  'monkey',
  'dragon',
  'master',
  'login'
]

const normalize = value => String(value || '').trim().toLowerCase()

const hasSequentialChars = value => {
  const text = normalize(value)
  const sequences = ['abcdefghijklmnopqrstuvwxyz', '0123456789']

  return sequences.some(sequence => {
    for (let index = 0; index <= sequence.length - 4; index++) {
      const segment = sequence.slice(index, index + 4)
      const reversedSegment = segment.split('').reverse().join('')

      if (text.includes(segment) || text.includes(reversedSegment)) {
        return true
      }
    }

    return false
  })
}

const hasRepeatedChars = value => /(.)\1{3,}/.test(value)

export const validatePasswordStrength = (password, account) => {
  const value = String(password || '')
  const accountValue = normalize(account)

  if (!value) return '请输入密码'
  if (value.length < 12) return '密码长度至少12位'
  if (!/[A-Z]/.test(value)) return '密码必须包含大写字母'
  if (!/[a-z]/.test(value)) return '密码必须包含小写字母'
  if (!/[0-9]/.test(value)) return '密码必须包含数字'
  if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?/~`"'\\]/.test(value)) return '密码必须包含特殊符号'
  if (/^[0-9]+$/.test(value)) return '密码不能为纯数字'
  if (SIMPLE_PATTERNS.some(pattern => normalize(value).includes(pattern))) return '密码包含简单组合，请勿使用'
  if (hasSequentialChars(value) || hasRepeatedChars(value)) return '密码包含简单组合，请勿使用'
  if (accountValue && normalize(value) === accountValue) return '密码不能与账号同名'

  return ''
}
